export const THREE_SIXTY_DEFAULT_AUDIO_FADEOUT_DURATION = 3;
export const THREE_SIXTY_DEFAULT_AUDIO_FADEIN_DURATION = 3;
export const THREE_SIXTY_DEFAULT_VIDEO_TEMPLATE_ID = '02c34216-e887-4241-8201-32bec1c72c3f';
export const THREE_SIXTY_DEFAULT_VIDEO_TRANSITION = 'none';
